import { useManufacturingAccessQuery } from '../components/Manufacturing/Manufacturing.queries';

interface ManufacturingAccessState {
  hasAccess: boolean;
  loading: boolean;
}

// STD-015: thin adapter over the TanStack Query hook so existing consumers keep
// the original { hasAccess, loading } contract. The query lives in
// Manufacturing.queries.ts (the only place allowed to import apiService).
// A failed access check is treated as "no access" (hasAccess: false), matching
// the previous try/catch behavior; it is a silent probe (no toast).
export function useManufacturingAccess(): ManufacturingAccessState {
  const query = useManufacturingAccessQuery();
  return {
    hasAccess: query.data ?? false,
    loading: query.isLoading,
  };
}
